import { useChoiceState } from '@context/ChoiceContext'

type MinMaxDuration = {
  minDuration: number | undefined
  maxDuration: number | undefined
}

export const useGetTreatmentDuration = (minAndMaxDuration: MinMaxDuration) => {
  const { patientType } = useChoiceState()
  const { minDuration, maxDuration } = minAndMaxDuration
  if (!minDuration || !maxDuration) return

  const treatmentDuration = patientType === 'OLD' ? minDuration : maxDuration

  return treatmentDuration
}
